export default __webpack_public_path__ + "static/media/bg-kahsh-labs-projects.e44cfafa.png";